module.exports = __webpack_public_path__ + "media/images/logos/logo-edone-black-header-e7202bc4b7d7f806e8cfc6a8a2cdcdee.jpg";